import {
  Avatar,
  Box,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from '@mui/material';
import React from 'react';
import { format } from 'date-fns';
import {
  MultilineText,
  displayNameInMessage,
  nameInitials,
} from '@xolv-mybrightlink/common';
import { Message } from '../../../type';
import { useUser } from '../../../hooks/store/useUser';

export const TheirBalloon = (props: { children: React.ReactNode }) => {
  return (
    <Box
      sx={{
        bgcolor: 'white',
        border: 'solid 0.5px #d8dade',
        borderRadius: '0px 30px 30px 30px',
        color: '#3b4559',
        px: 4,
        py: 2,
      }}
    >
      {props.children}
    </Box>
  );
};

type TheirMessageContainerProps = {
  message: Message;
  standalone?: boolean;
  children: () => React.ReactNode;
};

export const TheirMessageContainer = React.forwardRef<
  HTMLLIElement,
  TheirMessageContainerProps
>((props: TheirMessageContainerProps, ref) => {
  const author = useUser(props.message.authorGuid);
  const avatar = author ? nameInitials(author) : '';
  const authorName = author ? displayNameInMessage(author) : '';
  const formattedTime = format(props.message.createdDate.toDate(), 'HH:mm a');
  return (
    <ListItem
      ref={ref}
      sx={{
        alignItems: 'flex-start',
        flexWrap: 'nowrap',
        py: 2,
        px: 0,
        contentVisibility: 'auto',
      }}
    >
      <ListItemAvatar sx={{ minWidth: '42px' }}>
        <Avatar
          sx={{
            bgcolor: '#626a7a',
            width: 32,
            height: 32,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              textAlign: 'center',
              fontSize: 14,
              fontWeight: 600,
            }}
          >
            {avatar}
          </Box>
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        sx={{
          flex: 'unset',
          maxWidth: props.standalone ? '100%' : '70%',
          m: 0,
        }}
        primary={
          <MultilineText maxLines={1} sx={{ fontSize: 14, fontWeight: 500 }}>
            {authorName}
          </MultilineText>
        }
        secondary={
          <Box sx={{ display: 'flex', flexWrap: 'nowrap', minWidth: 0 }}>
            <Box sx={{ minWidth: 0 }}>{props.children()}</Box>
            <Box
              sx={{
                flexShrink: 0,
                pl: 2.5,
                alignSelf: 'flex-end',
                color: '#898f9b',
              }}
            >
              {formattedTime}
            </Box>
          </Box>
        }
        primaryTypographyProps={{ component: 'div' }}
        secondaryTypographyProps={{
          component: 'div',
          sx: { display: 'flex', mt: 1 },
        }}
      />
    </ListItem>
  );
});

TheirMessageContainer.displayName = 'TheirMessageContainer';
